import paymentEn from './en/en.json'
import paymentAr from './ar/ar.json'
import paymentEs from './es/es.json'
import paymentDe from './de/de.json'
import paymentIt from './it/it.json'
import paymentFr from './fr/fr.json'
import paymentPt from './pt/pt.json'
import paymentEl from './el/el.json'
import paymentBn from './bn/bn.json'
import paymentSr from './sr/sr.json'
import paymentCs from './cs/cs.json'
import paymentPl from './pl/pl.json'
import paymentHu from './hu/hu.json'
import paymentSk from './sk/sk.json'
import paymentRo from './ro/ro.json'
import paymentBg from './bg/bg.json'
import paymentMk from './mk/mk.json'
import paymentSq from './sq/sq.json'

const PaymentMessages = {
  en: { payment: { ...paymentEn } },
  ar: { payment: { ...paymentAr } },
  es: { payment: { ...paymentEs } },
  de: { payment: { ...paymentDe } },
  it: { payment: { ...paymentIt } },
  fr: { payment: { ...paymentFr } },
  pt: { payment: { ...paymentPt } },
  el: { payment: { ...paymentEl } },
  bn: { payment: { ...paymentBn } },
  sr: { payment: { ...paymentSr } },
  cs: { payment: { ...paymentCs } },
  pl: { payment: { ...paymentPl } },
  hu: { payment: { ...paymentHu } },
  sk: { payment: { ...paymentSk } },
  ro: { payment: { ...paymentRo } },
  bg: { payment: { ...paymentBg } },
  mk: { payment: { ...paymentMk } },
  sq: { payment: { ...paymentSq } },
}

export default PaymentMessages
